import { handleAppError } from "../components/handlers";

class LocationManager {
  constructor(locationData) {
    try {
      this.locationData = locationData;
      var full_address = {}
      full_address["zip_code"] = this.getZipCode()
      full_address["country"] = this.getCountry()
      full_address["state"] = this.getState()
      full_address["city"] = this.getCity()
      full_address['line'] = this.getLine()
      full_address['district'] = this.getDistrict()
      this.full_address = full_address
    } catch (err) {
      console.log("LocationManager -> constructor -> err", err)
      handleAppError(err)
    }
  }

  getFormattedAddress(){
    let address = {}
    this.locationData.address_components.map((item) => {
      if (this.isInList('postal_code', item.types)){
        address["zip_code"] = item.long_name
      }
      else if (this.isInList('country', item.types)){
        address["country"] = item.long_name
      }
      else if (this.isInList('administrative_area_level_1', item.types)){
        address["state"] = item.long_name
      }
      else if (this.isInList('administrative_area_level_2', item.types)){
        address["district"] = item.long_name
      }
      else if (this.isInList('locality', item.types)){
        address["city"] = item.long_name
      }
      else if (this.isInList('sublocality_level_3', item.types)){
        address["line2"] = item.long_name
      }
      else if (this.isInList('sublocality_level_2', item.types)){
        address["line2"] = address["line2"] ? address["line2"] + ", " + item.long_name : item.long_name
      }
      else if (this.isInList('sublocality_level_1', item.types)){
        address["line2"] = address["line2"] ? address["line2"] + ", " + item.long_name : item.long_name
      }
      else if (this.isInList("neighborhood", item.types)){
        address["line2"] = address["line2"] ? address["line2"] + ", " + item.long_name : item.long_name
      }
    })
    return address
  }

  isInList = (value, array) => {
    return array.indexOf(value) > -1;
  }

  getCountry() {
    var country = ''
    this.locationData.address_components.map((item) => {
      if (item.types.includes('country')) {
        country = item.long_name
      }
    })
    return country
  }

  getCity() {
    var city = ''
    this.locationData.address_components.map((item) => {
      if (item.types.includes('locality')) {
        city = item.long_name
      }
    })
    return city
  }

  getState() {
    var state = ''
    this.locationData.address_components.map((item) => {
      if (item.types.includes('administrative_area_level_1')) {
        state = item.long_name
      }
    })
    return state
  }

  getLine() {
    var line = ''
    this.locationData.address_components.map((item) => {
      if (item.types.includes('sublocality_level_1')) {
        line = item.long_name
      }
      else if (item.types.includes('sublocality_level_2')) {
        line = item.long_name
      }
      else if (item.types.includes("neighborhood")) {
        line = item.long_name
      }
    })
    return line
  }

  getDistrict() {
    var district = ''
    this.locationData.address_components.map((item) => {
      if (item.types.includes('administrative_area_level_2')) {
        district = item.long_name
      }
    })
    return district
  }

  getFullAddress() {
    return this.full_address
  }

  getZipCode() {
    var zipcode = ''
    this.locationData.address_components.map((item) => {
      if (item.types.includes('postal_code')) {
        zipcode = item.long_name
      }
    })
    return zipcode
  }
  
}

export default LocationManager